export default __webpack_public_path__ + "static/media/header.7bda9f20.png";